// dependencies
import React from "react";
import { connect, useSelector } from "react-redux";

import { AdminContainer, AdminTitle } from "../../../components/Admin";
import Link from "../../../components/Link";
import PageTitle from "../../../components/PageTitle";
import Typography from "../../../components/Text";
// component
import Notifications from "./Template";

import { getUserCompanyName } from "../../../selectors/app";

// styles
import css from "./NotificationsTemplate.module.scss";

const NotificationsTemplate = () => {
	const companyName = useSelector(getUserCompanyName);

	return (
		<>
			<PageTitle title={`Notifications${companyName ? ` - ${companyName}` : ""} - PerformYard`} />
			<AdminContainer>
				<div className={css.notificationsContainer}>
					<AdminTitle>Notifications</AdminTitle>
					<div className={css.pageDescription}>
						<Typography size="paragraph-2" weight="regular" color="neutral-9">
							Define the <b>default</b> notification preferences that will be applied to all new users in
							PerformYard.
						</Typography>

						<ul className={css.list}>
							<li>
								<Typography size="paragraph-3" weight="light" color="neutral-9">
									Each individual will be able to customize their own notifications using these
									preferences as a starting point.
								</Typography>
							</li>
							<li>
								<Typography size="paragraph-3" weight="light" color="neutral-9">
									When selecting a default time for a notification, keep in mind each user will be
									able to localize to their time zone.
								</Typography>
							</li>
							<li>
								<Typography size="paragraph-3" weight="light" color="neutral-9">
									Set the organization&apos;s default time zone under Company Settings{" "}
									<Link className={css.changeTZLink} href="/administration/">
										here.
									</Link>
								</Typography>
							</li>
						</ul>

						<Typography size="paragraph-2" weight="regular" color="neutral-9">
							You can change your personal notification settings{" "}
							<Link className={css.changeTZLink} href="/settings/notifications/">
								here.
							</Link>
						</Typography>
					</div>

					<div className={css.notificationWrapper}>
						<Notifications />
					</div>
				</div>
			</AdminContainer>
		</>
	);
};

const mapStateToProps = () => ({});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationsTemplate);
